import { render, staticRenderFns } from "./CustomerOrderCreatedPage.vue?vue&type=template&id=397d92d7&scoped=true"
import script from "./CustomerOrderCreatedPage.vue?vue&type=script&lang=js"
export * from "./CustomerOrderCreatedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d92d7",
  null
  
)

export default component.exports